import { surveyTag } from '@rockalingua/shared/surveys/constants';

const constants = {
  setupGuideOnboardingUrl: '/welcome/teacherPro/setupGuide',
  surveys: {
    subQueryKey: 'onboarding',
    count: 1,
    tags: [surveyTag.ONBOARDING, surveyTag.EVERYWHERE],
    skeleton: {
      ariaLabel: 'Loading onboarding',
      optionsCount: 5,
    },
    teachingLevelQuestion: {
      emphasis: 'What grades do you teach?',
      supportingText:
        'So we can show you the right material first. Select all that apply.',
    },
  },
};

export default constants;
